/**
 * Currency Constants for TavPlans
 * Centralized currency definitions
 */

export const CURRENCIES = [
  { value: "USD", label: "US Dollar (USD)", symbol: "$" },
  { value: "ETB", label: "Ethiopian Birr (ETB)", symbol: "Br" },
  { value: "EUR", label: "Euro (EUR)", symbol: "€" },
  { value: "GBP", label: "British Pound (GBP)", symbol: "£" },
  { value: "CAD", label: "Canadian Dollar (CAD)", symbol: "C$" },
  { value: "AUD", label: "Australian Dollar (AUD)", symbol: "A$" },
  { value: "JPY", label: "Japanese Yen (JPY)", symbol: "¥" },
  { value: "NGN", label: "Nigerian Naira (NGN)", symbol: "₦" },
  { value: "KES", label: "Kenyan Shilling (KES)", symbol: "KSh" },
  { value: "ZAR", label: "South African Rand (ZAR)", symbol: "R" }
];

export const DEFAULT_CURRENCY = "USD";

export const getCurrencyLabel = (code) => {
  const currency = CURRENCIES.find(c => c.value === code);
  return currency ? currency.label : code;
};

export const getCurrencySymbol = (code) => {
  const currency = CURRENCIES.find(c => c.value === code);
  return currency ? currency.symbol : code;
};
